import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 0;
  max-width: 1200px;
  margin: 0 auto;
`;

export const PageHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 32px;
`;

export const Breadcrumbs = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
  color: ${({ theme }) => theme.colors.textSecondary};

  span {
    color: ${({ theme }) => theme.colors.textPrimary};
    font-weight: 500;
  }
  
  /* Separator dot styled as a pseudo-element or character in JSX */
`;

export const SettingsCard = styled.div`
  background: ${({ theme }) => theme.colors.surface};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  overflow: hidden;
`;

export const TabsContainer = styled.div`
  display: flex;
  border-bottom: 1px solid ${({ theme }) => theme.colors.gray200};
  overflow-x: auto;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

export const Tab = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 4px;
  margin-right: 24px;
  white-space: nowrap;
  background: none;
  border: none;
  border-bottom: 2px solid ${({ theme, $isActive }) => $isActive ? theme.colors.primary : 'transparent'};
  color: ${({ theme, $isActive }) => $isActive ? theme.colors.primary : theme.colors.gray500};
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const CardContent = styled.div`
  padding: 32px;

  @media (max-width: 768px) {
    padding: 24px;
  }
`;

export const SectionTitle = styled.h2`
  font-size: 1rem;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 24px 0;
`;

export const AvatarUploadSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 32px;

  @media (max-width: 768px) {
    padding: 24px;
  }
  background-color: ${({ theme }) => theme.colors.surface};
  border-radius: 8px;
`;

export const AvatarPreview = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  overflow: hidden;
  position: relative;
  border: 4px solid ${({ theme }) => theme.colors.gray100};
  
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const UploadInfo = styled.p`
  color: ${({ theme }) => theme.colors.textPrimary};
  font-size: 0.9rem;
  font-weight: 600;
  margin: 0;
`;
export const FormField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.textPrimary};
`;

export const Select = styled.select`
  padding: 10px 12px;
  border-radius: 6px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.textPrimary};
  background-color: ${({ theme }) => theme.colors.surface};
  cursor: pointer;
  max-width: 300px;
  
  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const HelperText = styled.p`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.textSecondary};
  margin: 0;
`;